import React from "react";
import { CaseType } from "../../../utils/constant";

const DealerDetails = ({ caseDetails, leftPosition, topPosition }) => {
  return (
    <div
      className="details_tooltip_wrapper dealer-details-tooltip"
      style={{ left: leftPosition, top: topPosition }}
    >
      <div className="x_panel">
        <div className="x_title">
          <h2>Dealer Details</h2>
          <div className="clearfix"></div>
        </div>
        <div className="x_content">
          <div className="row">
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">Dealer Name</label>
                <div className="casedetailTxt clearfix" title="">
                  {caseDetails.dealer_name
                    ? `${caseDetails.dealer_name}`
                    : "--"}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">GCD Code</label>
                <div className="casedetailTxt clearfix" title="">
                  {caseDetails.gcd_code ? `${caseDetails.gcd_code}` : "--"}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">RP ID</label>
                <div className="casedetailTxt clearfix" title="">
                  {caseDetails.rp_id ? `${caseDetails.rp_id}` : "--"}
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">Dealer Contact</label>
                <div className="casedetailTxt clearfix" title="">
                  {caseDetails.dealer_mobile
                    ? `${caseDetails.dealer_mobile}`
                    : "--"}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">Dealer Type</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.dealer_types !== ""
                      ? CaseType[caseDetails.dealer_types]
                      : "--"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">Channel Type</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.channel_type_name !== ""
                      ? `${caseDetails.channel_type_name}`
                      : "--"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">City</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.dealer_city
                      ? `${caseDetails.dealer_city}`
                      : "--"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">AM</label>
                <div className="casedetailTxt clearfix" title="">
                  {`${caseDetails.am_name ? caseDetails.am_name : "-"} \n ${
                    caseDetails.am_mobile ? caseDetails.am_mobile : "-"
                  }`}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">BM</label>
                <div className="casedetailTxt clearfix" title="">
                  {`${caseDetails.bm_name ? caseDetails.bm_name : "-"} \n ${
                    caseDetails.bm_mobile ? caseDetails.bm_mobile : "-"
                  }`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealerDetails;
